<template>
  <div class="card">
    <Toast />
    <div class="title">Daftar Voucher</div>

    <Toolbar class="p-mb-2">
      <template slot="left">
        <Button
          label="Tambah"
          icon="pi pi-plus"
          class="p-button-success"
          @click="create_dialog = true"
        />

        <router-link
          :to="{
            name: 'print-vouchers'
          }"
          target="_blank"
        >
          <Button
            label="Print"
            icon="pi pi-print"
            v-if="vouchers.length > 0"
            style="margin-left: 1.5rem; font-size: 15px"
          />
        </router-link>
      </template>
      <template slot="right"> </template>
    </Toolbar>

    <DataTable
      :value="vouchers"
      :lazy="true"
      :paginator="true"
      :rows="limit"
      :totalRecords="total_records"
      :loading="loading.filter"
      @page="getVouchers($event)"
    >
      <template #header>
        <div
          class="p-grid p-fluid p-mb-2"
          v-if="user && user.role == 'SUPER_ADMIN'"
        >
          <AutoComplete
            class="p-col"
            placeholder="Jenis Voucher"
            :dropdown="true"
            :suggestions="jenis_voucher_filtered"
            v-model="filter.jenis_vouchers_selected"
            @complete="searchJenisVoucher($event)"
            field="type"
            optionLabel="type"
          >
            <template #item="slotProps">
              <div class="p-col">
                <div>{{ slotProps.item.type }}</div>
              </div>
            </template>
          </AutoComplete>
          <div class="p-col">
            <InputText v-model="filter.nominal" placeholder="Nominal" />
          </div>
          <div class="p-col">
            <Calendar
              v-model="filter.exp_date"
              :showIcon="true"
              dateFormat="yy-mm-dd"
              placeholder="Tanggal"
              :selectOtherMonths="true"
              :showButtonBar="true"
            />
          </div>
          <AutoComplete
            class="p-col"
            placeholder="Status"
            :dropdown="true"
            :suggestions="status_filtered"
            v-model="filter.status"
            @complete="searchStatus($event)"
            field="status"
            optionLabel="status"
          >
            <template #item="slotProps">
              <div class="p-col">
                <div>{{ slotProps.item.status }}</div>
              </div>
            </template>
          </AutoComplete>
        </div>

        <div class="p-grid p-fluid p-justify-center">
          <div class="p-col-12 p-md-4 p-lg-4">
            <Button label="Cari" class="p-button-info" @click="getVouchers()" />
          </div>
        </div>
      </template>

      <template #empty>Data tidak ada</template>
      <template #loading>Loading ...</template>

      <Column field="type" header="Tipe">
        <template #body="slotProps">
          {{ slotProps.data.type }}
        </template>
      </Column>
      <Column field="code" header="Kode">
        <template #body="slotProps">
          <span>{{ slotProps.data.code }}</span>
        </template>
      </Column>
      <Column field="amount" header="Nominal">
        <template #body="slotProps">
          <span>{{ slotProps.data.amount | currency }}</span>
        </template>
      </Column>
      <Column field="expired_date" header="Kedaluwarsa" min="">
        <template #body="slotProps">
          <span>{{ slotProps.data.expired_date }}</span>
        </template>
      </Column>
      <Column field="status" header="Status">
        <template #body="slotProps">
          <span
            v-if="slotProps.data.trans_id_redeemer"
            style="color: red; font-weight: bold"
            >Unavailable</span
          >
          <span v-else style="color: #17a30d; font-weight: bold"
            >Available</span
          >
        </template>
      </Column>

      <Column headerStyle="width: 5em">
        <template #body="slotProps">
          <Button
            v-if="slotProps.data.trans_id_redeemer == ''"
            icon="pi pi-trash"
            class="p-button-rounded p-button-secondary"
            @click="confirmDelete(slotProps.data)"
          ></Button>
        </template>
      </Column>
    </DataTable>

    <Dialog
      :visible.sync="create_dialog"
      :style="{ width: '450px' }"
      header="Buat Voucher"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-field">
        <label for="quantity">Jumlah</label>
        <InputNumber
          locale="id-ID"
          v-model="generate_data.quantity"
          placeholder="0"
          @keyup.prevent="is_error.quantity = false"
        />
        <small class="p-error" v-if="is_error.quantity">{{
          error_msg.quantity
        }}</small>
      </div>
      <div class="p-field">
        <label for="amount">Nominal (Rp)</label>
        <InputNumber
          locale="id-ID"
          v-model="generate_data.amount"
          placeholder="0"
          @keyup.prevent="is_error.amount = false"
        />
        <small class="p-error" v-if="is_error.amount">{{
          error_msg.amount
        }}</small>
      </div>
      <div class="p-field">
        <label for="">Kedaluwarsa</label>
        <InputText
          type="date"
          :min="tomorrow"
          v-model="generate_data.expired_date"
          @input="is_error.expired_date = false"
        />
        <small class="p-error" v-if="is_error.expired_date">{{
          error_msg.expired_date
        }}</small>
      </div>

      <template #footer>
        <Button
          label="Cancel"
          class="p-button-outlined"
          @click="create_dialog = false || resetGenerateData()"
        />
        <Button label="Add" class="btn btn-primary" @click="generateVoucher()">
          Add
          <span v-if="loading_add">
            <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
          </span>
        </Button>
      </template>
    </Dialog>

    <Dialog
      :visible.sync="delete_dialog"
      :style="{ width: '450px' }"
      header="Konfirmasi Penghapusan"
      :modal="true"
    >
      <div class="confirmation-content">
        Apakah kamu yakin ingin menghapus voucher
        <b>{{ delete_data.code }}</b>
      </div>

      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          class="p-button-text"
          @click="delete_dialog = false"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteVoucher()"
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
var moment = require('moment')

export default {
  computed: {
    ...mapState(['user', 'isAuthenticated'])
  },
  watch: {
    user() {
      this.getAuthUser()
    }
  },
  data() {
    return {
      moment: moment,
      today: new Date().toISOString().split('T')[0],
      tomorrow: new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
        .toISOString()
        .split('T')[0],
      loading_add: false,
      loading: {
        filter: false
      },

      filter: {
        jenis_vouchers_selected: null,
        nominal: '',
        exp_date: '',
        status: ''
      },

      vouchers: [],
      jenis_voucher_filtered: null,
      jenis_vouchers: [{ type: 'SHOPPING' }, { type: 'REFUND' }],
      status_filtered: null,
      status: [{ status: 'available' }, { status: 'unavailable' }],
      delete_dialog: false,
      create_dialog: false,

      is_error: {
        quantity: false,
        amount: false,
        expired_date: false
      },

      error_msg: {
        quantity: '',
        amount: '',
        expired_date: ''
      },

      generate_data: {
        quantity: null,
        amount: null,
        expired_date: null
      },

      delete_data: {},

      limit: 5,
      total_records: 0
    }
  },
  mounted() {
    this.getAuthUser()
    this.getVouchers()
  },
  methods: {
    getAuthUser() {
      console.info(this.user)
    },

    getVouchers(event) {
      let type = ''
      if (
        this.filter.jenis_vouchers_selected &&
        this.filter.jenis_vouchers_selected.type
      ) {
        type = this.filter.jenis_vouchers_selected.type
      }

      let exp_date = this.filter.exp_date
        ? moment(this.filter.exp_date).format('YYYY-MM-DD')
        : ''

      let status = ''
      if (this.filter.status && this.filter.status.status) {
        status = this.filter.status.status
      }

      let page = 1
      if (event) {
        page = event.page + 1
      }

      this.loading.filter = true
      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/vouchers?jenis_voucher=${type}&nominal=${this.filter.nominal}&exp_date=${exp_date}&status=${status}&page=${page}&limit=${this.limit}`
        )
        .then(response => {
          this.loading.filter = false
          if (response.status === 200) {
            this.vouchers = response.data.data.vouchers
            this.total_records = response.data.data.total
          }
        })
    },

    searchJenisVoucher(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.jenis_voucher_filtered = [...this.jenis_vouchers]
        } else {
          this.jenis_voucher_filtered = this.jenis_vouchers.filter(item => {
            return item.type.toLowerCase().startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    searchStatus(event) {
      setTimeout(() => {
        if (!event.query.trim().length) {
          this.status_filtered = [...this.status]
        } else {
          this.status_filtered = this.status.filter(item => {
            return item.status
              .toLowerCase()
              .startsWith(event.query.toLowerCase())
          })
        }
      }, 250)
    },

    generateVoucher() {
      if (!this.generate_data.quantity) {
        this.is_error.quantity = true
        this.error_msg.quantity = 'Isi jumlah'
      }
      if (!this.generate_data.amount) {
        this.is_error.amount = true
        this.error_msg.amount = 'Isi nominal'
      }
      if (!this.generate_data.expired_date) {
        this.is_error.expired_date = true
        this.error_msg.expired_date = 'Pilih kedaluwarsa'
      }
      if (this.generate_data.expired_date <= this.today) {
        this.is_error.expired_date = true
        this.error_msg.expired_date = 'Tanggal kedaluwarsa sudah tidak sesuai'
      }

      if (
        !this.is_error.quantity &&
        !this.is_error.amount &&
        !this.is_error.expired_date
      ) {
        this.generate_data.quantity = Number(this.generate_data.quantity)
        this.loading_add = true
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/vouchers/generate`,
            this.generate_data
          )
          .then(response => {
            if (response.status === 200) {
              this.getVouchers()
              this.$toast.add({
                severity: 'success',
                summary: 'Generate Voucher Success',
                life: 3000
              })
              this.loading_add = false
              this.resetGenerateData()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Generate Voucher Failed',
                life: 3000
              })
              this.loading_add = false
            }
          })

        this.create_dialog = false
      }
    },

    resetGenerateData() {
      this.generate_data = {
        quantity: null,
        amount: null,
        expired_date: null
      }
      this.is_error = {
        quantity: false,
        amount: false,
        expired_date: false
      }
      this.error_msg = {
        quantity: '',
        amount: '',
        expired_date: ''
      }
    },

    confirmDelete(voucher) {
      this.delete_data = voucher
      this.delete_dialog = true
    },

    deleteVoucher() {
      this.$http
        .delete(
          `${process.env.VUE_APP_API_URL}/vouchers/${this.delete_data.id}`
        )
        .then(response => {
          this.delete_dialog = false
          if (response.status === 200) {
            this.$toast.add({
              severity: 'success',
              summary: 'Berhasil hapus voucher',
              life: 3000
            })
            this.getVouchers()
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Gagal hapus voucher',
              detail: 'Voucher telah digunakan',
              life: 3000
            })
          }
        })
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep(.p-datatable table) {
  border-collapse: collapse;
}

::v-deep(.p-datatable th),
::v-deep(.p-datatable td) {
  border: 1px solid #ccc !important;
  padding: 8px;
}
</style>
